import { DataManagementHeader } from '../../data-management/components/data-management-header';

type Props = {
  onClickBack: () => void;
};

export const CalculationsHeader = ({ onClickBack }: Props) => {
  return <DataManagementHeader title="Calculations" icon="calculate" onClickBack={onClickBack} />;
};
